import { render, staticRenderFns } from "./wap.vue?vue&type=template&id=5103215e&scoped=true"
import script from "./wap.vue?vue&type=script&lang=js"
export * from "./wap.vue?vue&type=script&lang=js"
import style0 from "./wap.vue?vue&type=style&index=0&id=5103215e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103215e",
  null
  
)

export default component.exports